module.exports = __webpack_public_path__ + "img/no-activated-sub-repositories-state.e66b49f.png";